<template>
  <div>
    <!-- MAIN -->
    <div class="breadcrumbs ace-save-state" id="breadcrumbs">
      <ul class="breadcrumb">
        <li>
          <i class="ace-icon fa fa-home home-icon"></i>
          <a href="#/">ダッシュボード</a>
        </li>
        <li class="active">設定</li>
      </ul><!-- /.breadcrumb -->
    </div>
    <!-- END MAIN -->
    <div class="page-content" style="padding-top:100px">
      <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
      <div class="row">
        <div class="col-xs-12">
          <div class="tabbable">
            <ul class="nav nav-tabs padding-12 tab-color-blue background-blue" id="myTab4">
              <li v-bind:class="{'active': checkActiveTab('setting1')}">
                <a data-toggle="tab" href="#setting1" aria-expanded="true" @click="changeTabActive('setting1')">NFC読み出し位置</a>
              </li>
              <li v-bind:class="{'active': checkActiveTab('setting2')}">
                <a data-toggle="tab" href="#setting2" aria-expanded="false" @click="changeTabActive('setting2')">キートークン有効期間</a>
              </li>
              <li v-bind:class="{'active': checkActiveTab('setting3')}">
                <a data-toggle="tab" href="#setting3" aria-expanded="false" @click="changeTabActive('setting3')">スマートフォン自動承認</a>
              </li>
              <li v-bind:class="{'active': checkActiveTab('setting4')}">
                <a data-toggle="tab" href="#setting4" aria-expanded="false" @click="changeTabActive('setting4')">照合ログ種別</a>
              </li>
            </ul>
            <div class="tab-content">
              <div class="alert alert-success" v-if="message_success">
                {{ message_success }}
              </div>
              <div class="alert alert-danger" v-if="message_error">
                {{ message_error }}
              </div>
              <div id="setting1" class="tab-pane" v-bind:class="{'active': checkActiveTab('setting1')}">
                <div class="page-header">
                  <div class="checkbox">
                    <h3>設定</h3>
                  </div>
                </div><!-- /.page-header -->
                <div class="row">
                  <div class="col-xs-12">
                    <div class="code">
                      <div class="profile-info-row">
                        <div style="width:150px"><b>NFCカード動作設定</b></div>
                        <div class="profile-info-value">
                          <select class="form-control" data-placeholder="製品名選択" v-model="settingInfor.pCodeConfigType">
                            <option v-for="item in listNfcSetting" v-bind:value="item.type" v-bind:key="item.type">
                              {{item.name}}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="possition">
                      <div><b>読み取り位置</b></div>
                      <div class="profile-info-row">
                        <div class="profile-info-row">
                          <div class="main-title">個人ID 1 位置</div>
                          <div class="profile-info-value">
                            <span id="readposition1_error" class="error_m"></span>
                            <input type="number" class="form-control input-sm" v-model="settingInfor.readPosition1" :disabled="editStatus" min="0" max="47">
                          </div>
                          <div class="sub-title">長さ</div>
                          <div class="profile-info-value">
                            <span id="readlength1_error" class="error_m"></span>
                            <input type="number" class="form-control input-sm" v-model="settingInfor.readLength1" :disabled="editStatus" min="0" max="20">
                          </div>
                        </div>
                      </div>
                      <div class="profile-info-row">
                        <div class="profile-info-row">
                          <div class="main-title">個人ID 2 位置</div>
                          <div class="profile-info-value">
                            <span id="readposition2_error" class="error_m"></span>
                            <input type="number" class="form-control input-sm" v-model="settingInfor.readPosition2" :disabled="editStatus" min="0" max="47">
                          </div>
                          <div class="sub-title">長さ</div>
                          <div class="profile-info-value">
                            <span id="readlength2_error" class="error_m"></span>
                            <input type="number" class="form-control input-sm" v-model="settingInfor.readLength2" :disabled="editStatus" min="0" max="20">
                          </div>
                        </div>
                      </div>
                      <div class="profile-info-row">
                        <div class="profile-info-row">
                          <div class="main-title">個人ID 3 位置</div>
                          <div class="profile-info-value">
                            <span id="readposition3_error" class="error_m"></span>
                            <input type="number" class="form-control input-sm" v-model="settingInfor.readPosition3" :disabled="editStatus" min="0" max="47">
                          </div>
                          <div class="sub-title">長さ</div>
                          <div class="profile-info-value">
                            <span id="readlength3_error" class="error_m"></span>
                            <input type="number" class="form-control input-sm" v-model="settingInfor.readLength3" :disabled="editStatus" min="0" max="20">
                          </div>
                        </div>
                      </div>
                      <div class="profile-info-row">
                        <div class="profile-info-row">
                          <div class="main-title">固定コード 1 位置</div>
                          <div class="profile-info-value">
                            <span id="ownercodeposition1_error" class="error_m"></span>
                            <input type="number" class="form-control input-sm" v-model="settingInfor.ownerCodePosition1" :disabled="getEditStatus()" min="0" max="47">
                          </div>
                          <div class="sub-title">長さ</div>
                          <div class="profile-info-value">
                            <span id="ownercodelength1_error" class="error_m"></span>
                            <input type="number" class="form-control input-sm" v-model="settingInfor.ownerCodeLength1" :disabled="getEditStatus()" min="0" max="20">
                          </div>
                        </div>
                      </div>
                      <div class="profile-info-row">
                        <div class="profile-info-row">
                          <div class="main-title">固定コード 2 位置</div>
                          <div class="profile-info-value">
                            <span id="ownercodeposition2_error" class="error_m"></span>
                            <input type="number" class="form-control input-sm" v-model="settingInfor.ownerCodePosition2" :disabled="getEditStatus()" min="0" max="47">
                          </div>
                          <div class="sub-title">長さ</div>
                          <div class="profile-info-value">
                            <span id="ownercodelength2_error" class="error_m"></span>
                            <input type="number" class="form-control input-sm" v-model="settingInfor.ownerCodeLength2" :disabled="getEditStatus()" min="0" max="20">
                          </div>
                        </div>
                      </div>
                      <div class="profile-info-row">
                        <div class="profile-info-row">
                          <div class="main-title">固定コード 3 位置</div>
                          <div class="profile-info-value">
                            <span id="ownercodeposition3_error" class="error_m"></span>
                            <input type="number" class="form-control input-sm" v-model="settingInfor.ownerCodePosition3" :disabled="getEditStatus()" min="0" max="47">
                          </div>
                          <div class="sub-title">長さ</div>
                          <div class="profile-info-value">
                            <span id="ownercodelength3_error" class="error_m"></span>
                            <input type="number" class="form-control input-sm" v-model="settingInfor.ownerCodeLength3" :disabled="getEditStatus()"  min="0" max="20">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="code">
                      <div class="profile-info-row">
                        <div class="profile-info-name" style="width:156px;text-align:left;color:#000;padding-left:0px"><b>固定コード有効・無効</b></div>
                        <div class="profile-info-value">
                          <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="settingInfor.isOwnerCodeValid"  :disabled="editStatusException">
                          <span class="lbl"></span>
                        </div>
                      </div>
                    </div>
                    <div class="code">
                      <div class="profile-info-row">
                        <div class="main-title"><b>固定コード</b></div>
                        <div class="profile-info-value" style="width:550px;border:0px solid">
                          <span id="ownercode_error" class="error_m"></span>
                          <input type="text" class="form-control input-sm" v-model="settingInfor.ownerCode" :disabled="getEditStatus()">
                        </div>
                      </div>
                    </div>
                    <div class="felica">
                      <div><b>Felica認証情報</b></div>
                      <div class="profile-info-row">
                        <div class="profile-info-row">
                          <div class="main-title">システムコード</div>
                          <div class="profile-info-value">
                            <span id="systemcode_error" class="error_m"></span>
                            <input type="text" class="form-control input-sm" v-model="settingInfor.systemCode" :disabled="checkIsMifare()">
                          </div>
                          <div class="sub-title">サービスコード</div>
                          <div class="profile-info-value">
                            <span id="servicecode_error" class="error_m"></span>
                            <input type="text" class="form-control input-sm" v-model="settingInfor.serviceCode" :disabled="checkIsMifare()">
                          </div>
                        </div>
                      </div>
                      <div class="profile-info-row">
                        <div class="profile-info-row">
                          <div class="main-title">ブロックカウント</div>
                          <div class="profile-info-value">
                            <span id="blockcount_error" class="error_m"></span>
                            <input type="number" min="0" class="form-control input-sm" v-model="settingInfor.blockCount" :disabled="checkIsMifare()">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="mifare">
                      <div><b>MIFARE認証情報</b></div>
                      <div class="profile-info-row">
                        <div class="profile-info-row">
                          <div class="main-title">キー種別</div>
                          <div class="profile-info-value">
                            <div style="display:inline-block;width:80px">
                              <input type="radio" name="key" value="1" v-model="settingInfor.keyType" :disabled="checkIsFalica()"/>
                              <label>Aキー</label>
                            </div>
                            <div style="display:inline-block;width:80px">
                              <input type="radio" name="key" value="0" v-model="settingInfor.keyType" :disabled="checkIsFalica()"/>
                              <label>Bキー</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="profile-info-row">
                        <div class="profile-info-row">
                          <div class="main-title">キー情報</div>
                          <div class="profile-info-value" style="width:450px">
                            <span id="keyvalue_error" class="error_m"></span>
                            <input type="text" class="form-control input-sm" v-model="settingInfor.keyValue" :disabled="checkIsFalica()">
                          </div>
                        </div>
                      </div>
                      <div class="profile-info-row">
                        <div class="profile-info-row">
                          <div class="main-title">セクタ No</div>
                          <div class="profile-info-value">
                            <span id="sectornumber_error" class="error_m"></span>
                            <input type="number" class="form-control input-sm" v-model="settingInfor.sectorNumber" :disabled="checkIsFalica()">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="profile-info-row">
                      <button class="btn btn-info" type="button" @click="validateBeforeSubmit()">設定を保存</button>
                    </div>
                  </div><!-- /.span -->
                </div><!-- /.row -->
              </div>
              <div id="setting2" class="tab-pane" v-bind:class="{'active': checkActiveTab('setting2')}">
                <div class="page-header">
                  <div class="checkbox">
                    <h3>設定</h3>
                  </div>
                </div><!-- /.page-header -->
                <div class="row">
                  <div class="col-xs-12">
                    <div>
                      <div class="profile-info-row">
                        <div class="profile-info-name" style="width:250px;text-align:left">オフラインでの鍵有効期間</div>
                        <div class="profile-info-value">
                          <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="settingInfor.keyTokenRefreshable">
                          <span class="lbl"></span>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="profile-info-row">
                        <div class="profile-info-name" style="width:250px;text-align:left">オフラインでの鍵有効期間</div>
                        <div class="profile-info-value">
                          <select class="form-control" v-model="settingInfor.keyTokenLifetime">
                            <option v-for="item in listKeyTokenLifetime" v-bind:value="item.value" v-bind:key="item.value">
                              {{item.text}}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div style="margin-bottom:10px">
                      <div class="profile-info-row">
                        <div class="profile-info-name" style="width:250px;text-align:left">更新間隔</div>
                        <div class="profile-info-value">
                          <select class="form-control" v-model="settingInfor.keyTokenRefreshRate">
                            <option v-for="item in listKeyTokenRefreshRate" v-bind:value="item.value" v-bind:key="item.value">
                              {{item.text}}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="profile-info-row">
                      <button class="btn btn-info" type="button" @click="saveKeyToken()">設定を保存</button>
                    </div>
                  </div><!-- /.span -->
                </div><!-- /.row -->
              </div>
              <div id="setting3" class="tab-pane" v-bind:class="{'active': checkActiveTab('setting3')}">
                <div class="page-header">
                  <div class="checkbox">
                    <h3>設定</h3>
                  </div>
                </div><!-- /.page-header -->
                <div class="row">
                  <div class="col-xs-12">
                    <div style="margin-bottom:15px">
                      <div class="profile-info-row">
                        <div class="profile-info-name" style="width:250px;text-align:left">スマートフォン自動承認機能</div>
                        <div class="profile-info-value">
                          <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="settingInfor.phonesBeValid">
                          <span class="lbl"></span>
                        </div>
                      </div>
                    </div>
                    <div class="profile-info-row">
                      <button class="btn btn-info" type="button" @click="savePhoneStatus()">設定を保存</button>
                    </div>
                  </div><!-- /.span -->
                </div><!-- /.row -->
              </div>
              <div id="setting4" class="tab-pane" v-bind:class="{'active': checkActiveTab('setting4')}">
                <div class="page-header">
                  <div class="checkbox">
                    <h3>設定</h3>
                  </div>
                </div><!-- /.page-header -->
                <div class="row">
                  <div class="col-xs-12">
                    <div class="alert alert-danger" v-if="errorMessageLogs!==''">
                      {{ errorMessageLogs }}
                    </div>
                    <table id="simple-table" class="table  table-bordered table-hover dataTable" v-if="listConfifLog!=null">
                      <thead>
                        <tr>
                          <th class="center">照合ログID</th>
                          <th>ログ名称</th>
                          <th class="center" style="width:110px">アクション</th>
                        </tr>
                      </thead>
                      <tbody v-for="(item, index) in listConfifLog" :key="index">
                        <tr>
                          <td class="center accessLogId">{{item.accessLogId}}</td>
                          <td class="logLabel">{{item.logLabel}}</td>
                          <td class="center" style="width:110px">
                            <button class="btn btn-xs btn-info" @click="handleEdit(item.accessLogId)">編集</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table id="simple-table" class="table  table-bordered table-hover dataTable" v-else>
                      <thead>
                        <tr>
                          <th>照合ログID</th>
                          <th>ログ名称</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr><td colspan="3">該当するデーターがありません。</td></tr>
                      </tbody>
                    </table>
                    <div class="row" v-if="pages>0">
                      <div class="col-xs-12">
                        <div class="dataTables_paginate paging_simple_numbers">
                          <paginate
                            :page-count="pages"
                            :page-range="3"
                            :margin-pages="2"
                            :click-handler="handleCurrentChange"
                            :prev-text="'<<'"
                            :next-text="'>>'"
                            :container-class="'pagination'"
                            :page-class="'page-item'">
                          </paginate>
                        </div>
                      </div>
                    </div>
                  </div><!-- /.span -->
                </div><!-- /.row -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as Config from '../../config'

export default {
  data () {
    return {
      listConfifLog: null,
      errorMessageLogs: '',
      pages: 0,
      selected: 100,
      pageSizeOptions: [25, 50, 100, 1000],
      listQuery: {
        currPage: 1,
        pageSize: 100
      },
      listKeyTokenLifetime: [
        { text: '1時間', value: 60 },
        { text: '3時間', value: 180 },
        { text: '6時間', value: 360 },
        { text: '12時間', value: 720 },
        { text: '1日', value: 1440 },
        { text: '3日', value: 4320 },
        { text: '5日', value: 7200 },
        { text: '10日', value: 14400 },
        { text: '30日', value: 43200 }
      ],
      listKeyTokenRefreshRate: [
        { text: '30分', value: 30 },
        { text: '60分', value: 60 },
        { text: '90分', value: 90 },
        { text: '120分', value: 120 },
        { text: '150分', value: 150 },
        { text: '180分', value: 180 }
      ],
      settingInfor: {
        type: 0,
        isOwnerCodeValid: true,
        pCodeConfigType: 0,
        ownerCodePosition1: 0,
        ownerCodePosition2: 0,
        ownerCodePosition3: 0,
        ownerCodeLength1: 0,
        ownerCodeLength2: 0,
        ownerCodeLength3: 0,
        readPosition1: 0,
        readPosition2: 0,
        readPosition3: 0,
        readLength1: 0,
        readLength2: 0,
        readLength3: 0,
        systemCode: '',
        serviceCode: '',
        blockCount: 0,
        keyType: 0,
        keyValue: '',
        sectorNumber: 0,
        ownerCode: '',
        phonesBeValid: false,
        keyTokenRefreshable: false,
        keyTokenLifetime: 60,
        keyTokenRefreshRate: 30
      },
      scorp: ['accessLogId', 'logLabel'],
      editStatus: true,
      editStatusException: true,
      listNfcSetting: null,
      loading: false,
      isFelica: true,
      isMifare: true,
      flag: true,
      message_success: '',
      message_error: '',
      fistTime: true
    }
  },
  watch: {
    'settingInfor.pCodeConfigType': 'checkEditStatus'
  },
  mounted () {
    var vm = this
    vm.getTypeInfo()
    vm.getOwnerInfor()
    vm.getListConfigLog()
    $('#nav-search-input').keyup(function (e) {
      if (e.keyCode === 13) {
        vm.search()
      }
    })
    if (typeof localStorage.pageSizeLogConfig === 'undefined') {
      localStorage.setItem('pageSizeLogConfig', 100)
      this.selected = localStorage.pageSizeLogConfig
    } else {
      this.selected = localStorage.pageSizeLogConfig
    }
    if (typeof localStorage.configLogSortKey === 'undefined') {
      localStorage.setItem('configLogSortKey', 'accessLogId')
    }
    if (typeof localStorage.configLogSortName === 'undefined') {
      localStorage.setItem('configLogSortName', 'desc')
    }
    if (typeof localStorage.activeTab === 'undefined') {
      localStorage.setItem('activeTab', 'setting1')
    }
  },
  methods: {
    getEditStatus () {
      if (this.settingInfor.isOwnerCodeValid && (this.editStatusException === false)) {
        return false
      } else {
        return true
      }
    },
    checkIsFalica () {
      var vm = this
      if (vm.isFelica) {
        return true
      } else {
        return false
      }
    },
    checkIsMifare () {
      var vm = this
      if (vm.isMifare) {
        return true
      } else {
        return false
      }
    },
    checkActiveTab (activeTab) {
      if (localStorage.activeTab === activeTab) {
        return true
      } else {
        return false
      }
    },
    changeTabActive (tabName) {
      this.message_error = ''
      this.message_success = ''
      localStorage.setItem('activeTab', tabName)
    },
    handleEdit (id) {
      this.$router.push({name: 'configLogEdit', query: { id: id }})
    },
    // 検索項目チェンジ(操作ログ)
    addRomoveScorp (classname, scorpname) {
      if ($('.' + classname).prop('checked')) {
        this.scorp.push(scorpname)
      } else {
        this.scorp.splice($.inArray(scorpname, this.scorp), 1)
      }
    },
    ShowHideColumn: function (e) {
      var $tbl = $('#simple-table')
      var colToHide = $tbl.find('.' + $(e.target).attr('name'))
      $(colToHide).toggle()
    },
    getListConfigLog () {
      this.$http.get(Config.CONFIG_LOG_API + '?limit=' + localStorage.pageSizeLogConfig + '&page=' + this.listQuery.currPage + '&sortKey=' + localStorage.configLogSortName + ':' + localStorage.configLogSortKey)
        .then(response => {
          console.log(response)
          this.pages = Math.ceil((response.body.maxRecords) / localStorage.pageSizeLogConfig)
          this.listConfifLog = response.body.logConfigs
          console.log(response)
        })
        .catch((error) => {
          this.listConfifLog = null
          this.loading = false
          switch (error.status) {
            case 400:
              this.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.errorMessageLogs = '照合ログマスターの取得権限がありません。'
              break
            case 500:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
        })
    },
    handleSizeChange () {
      this.listQuery.pageSize = $('#pageSizeOptions').val()
      localStorage.setItem('pageSizeLogConfig', this.listQuery.pageSize)
      this.listQuery.currPage = 1
      this.getListConfigLog()
    },
    handleCurrentChange (val) {
      this.listQuery.currPage = val
      this.getListConfigLog()
    },
    // ソート
    sort (sortkey, elementname) {
      this.loading = true
      if ($('#' + elementname).hasClass('sorting_asc')) {
        $('#simple-table>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_asc')
        $('#' + elementname).addClass('sorting_desc')
        localStorage.setItem('configLogSortName', 'desc')
        localStorage.setItem('configLogSortKey', sortkey)
      } else {
        $('#simple-table>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_desc')
        $('#' + elementname).addClass('sorting_asc')
        localStorage.setItem('configLogSortName', 'asc')
        localStorage.setItem('configLogSortKey', sortkey)
      }
      this.search()
    },
    search () {
      console.log('search function')
    },
    saveKeyToken () {
      var vm = this
      if (vm.settingInfor.keyTokenRefreshRate >= vm.settingInfor.keyTokenLifetime) {
        this.message = '更新間隔は、有効期間より長く設定することはできません。'
        $('#error-alert').fadeTo(2000, 500).slideUp(500, function () {
          $('#error-alert').slideUp(500)
        })
      } else {
        vm.loading = true
        const Infor = {
          keyTokenRefreshable: vm.settingInfor.keyTokenRefreshable,
          keyTokenLifetime: vm.settingInfor.keyTokenLifetime,
          keyTokenRefreshRate: vm.settingInfor.keyTokenRefreshRate
        }
        console.log(Infor)
        this.$http.put(Config.OWNER_API + '/' + localStorage.ownerId, Infor)
          .then(response => {
            console.log(response)
            this.loading = false
            this.message_success = Config.EDIT_SETTING_API_SUCCESS
            this.message_error = ''
          })
          .catch((error) => {
            if (error.body) {
              this.loading = false
              this.message_error = Config.ADD_API_ERROR
              this.message_success = ''
            } else {
              this.loading = false
              this.message_error = Config.SERVER_CONNECT_ERROR
              this.message_success = ''
            }
          })
      }
    },
    savePhoneStatus () {
      var vm = this
      vm.loading = true
      const Infor = {
        phonesBeValid: vm.settingInfor.phonesBeValid
      }
      console.log(Infor)
      this.$http.put(Config.OWNER_API + '/' + localStorage.ownerId, Infor)
        .then(response => {
          console.log(response)
          this.loading = false
          this.message_success = Config.EDIT_SETTING_API_SUCCESS
          this.message_error = ''
        })
        .catch((error) => {
          this.message_success = ''
          if (error.body) {
            this.loading = false
            this.message_error = Config.ADD_API_ERROR
          } else {
            this.loading = false
            this.message_error = Config.SERVER_CONNECT_ERROR
          }
        })
    },
    validateBeforeSubmit () {
      this.flag = 0
      if (this.settingInfor.readPosition1 === null || this.settingInfor.readPosition1 === '') {
        $('#readposition1_error').html('個人ID 1 位置は必須項目です。')
        this.flag += 1
      } else {
        $('#readposition1_error').html('')
      }
      if (this.settingInfor.readPosition2 === null || this.settingInfor.readPosition2 === '') {
        $('#readposition2_error').html('個人ID 2 位置は必須項目です。')
        this.flag += 1
      } else {
        $('#readposition2_error').html('')
      }
      if (this.settingInfor.readPosition3 === null || this.settingInfor.readPosition3 === '') {
        $('#readposition3_error').html('個人ID 3 位置は必須項目です。')
        this.flag += 1
      } else {
        $('#readposition3_error').html('')
      }
      if (this.settingInfor.readLength1 === null || this.settingInfor.readLength1 === '') {
        $('#readlength1_error').html('長さは必須項目です。')
        this.flag += 1
      } else {
        $('#readlength1_error').html('')
      }
      if (this.settingInfor.readLength2 === null || this.settingInfor.readLength2 === '') {
        $('#readlength2_error').html('長さは必須項目です。')
        this.flag += 1
      } else {
        $('#readlength2_error').html('')
      }
      if (this.settingInfor.readLength3 === null || this.settingInfor.readLength3 === '') {
        $('#readlength3_error').html('長さは必須項目です。')
        this.flag += 1
      } else {
        $('#readlength3_error').html('')
      }
      if (this.settingInfor.ownerCodePosition1 === null || this.settingInfor.ownerCodePosition1 === '') {
        $('#ownercodeposition1_error').html('固定コード1位置は必須項目です。')
        $('#ownerCodePosition1').addClass('error')
        this.flag += 1
      } else {
        $('#ownercodeposition1_error').html('')
        $('#ownerCodePosition1').removeClass('error')
      }
      if (this.settingInfor.ownerCodePosition2 === null || this.settingInfor.ownerCodePosition2 === '') {
        $('#ownercodeposition2_error').html('固定コード2位置は必須項目です。')
        $('#ownerCodePosition2').addClass('error')
        this.flag += 1
      } else {
        $('#ownercodeposition2_error').html('')
        $('#ownerCodePosition2').removeClass('error')
      }
      if (this.settingInfor.ownerCodePosition3 === null || this.settingInfor.ownerCodePosition3 === '') {
        $('#ownercodeposition3_error').html('固定コード3位置は必須項目です。')
        $('#ownerCodePosition3').addClass('error')
        this.flag += 1
      } else {
        $('#ownercodeposition3_error').html('')
        $('#ownerCodePosition3').removeClass('error')
      }
      if (this.settingInfor.ownerCodeLength1 === null || this.settingInfor.ownerCodeLength1 === '') {
        $('#ownercodelength1_error').html('長さは必須項目です。')
        this.flag += 1
      } else {
        $('#ownercodelength1_error').html('')
      }
      if (this.settingInfor.ownerCodeLength2 === null || this.settingInfor.ownerCodeLength2 === '') {
        $('#ownercodelength2_error').html('長さは必須項目です。')
        this.flag += 1
      } else {
        $('#ownercodelength2_error').html('')
      }
      if (this.settingInfor.ownerCodeLength3 === null || this.settingInfor.ownerCodeLength3 === '') {
        $('#ownercodelength3_error').html('長さは必須項目です。')
        this.flag += 1
      } else {
        $('#ownercodelength3_error').html('')
      }
      var english = /^[A-Za-z0-9]*$/
      var englishHexa = /^[A-Fa-f0-9]*$/
      if (this.settingInfor.isOwnerCodeValid && (this.editStatusException === false)) {
        if (this.settingInfor.ownerCode === null || this.settingInfor.ownerCode === '') {
          $('#ownercode_error').html('固定コードは必須項目です。')
          this.flag += 1
        } else if (!englishHexa.test(this.settingInfor.ownerCode) || this.settingInfor.ownerCode.length > 40) {
          $('#ownercode_error').html('固定コードは半角英文字（A〜F、a〜f）および半角数字で1〜40文字以内で入力してください。')
          this.flag += 1
        } else {
          $('#ownercode_error').html('')
        }
      } else {
        $('#ownercode_error').html('')
      }
      if (!this.isMifare) {
        if (this.settingInfor.systemCode === null || this.settingInfor.systemCode === '') {
          $('#systemcode_error').html('システムコードは必須項目です。')
          this.flag += 1
        } else if (!english.test(this.settingInfor.systemCode) || this.settingInfor.systemCode.length > 4) {
          $('#systemcode_error').html('システムコードは半角英数字4文字で入力してください。')
          this.flag += 1
        } else {
          $('#systemcode_error').html('')
        }

        if (this.settingInfor.serviceCode === null || this.settingInfor.serviceCode === '') {
          $('#servicecode_error').html('サービスコードは必須項目です。')
          this.flag += 1
        } else if (!english.test(this.settingInfor.serviceCode) || this.settingInfor.serviceCode.length > 4) {
          $('#servicecode_error').html('サービスコードは半角英数字4文字で入力してください。')
          this.flag += 1
        } else {
          $('#servicecode_error').html('')
        }
        if (this.settingInfor.blockCount === null || this.settingInfor.blockCount === '') {
          $('#blockcount_error').html('ブロックカウントは必須項目です。')
          this.flag += 1
        } else if (this.settingInfor.blockCount > 255) {
          $('#blockcount_error').html('ブロックカウントは0〜255の半角数字で入力してください。')
          this.flag += 1
        } else {
          $('#blockcount_error').html('')
        }
      } else {
        $('#systemcode_error').html('')
        $('#servicecode_error').html('')
        $('#blockcount_error').html('')
      }
      if (!this.isFelica) {
        if (this.settingInfor.keyValue === null || this.settingInfor.keyValue === '') {
          $('#keyvalue_error').html('キー情報は必須項目です。')
          this.flag += 1
        } else if (!englishHexa.test(this.settingInfor.keyValue) || this.settingInfor.keyValue.length !== 12) {
          $('#keyvalue_error').html('キー情報は半角英文字（A〜F、a〜f）および半角数字で12文字入力してください。')
          this.flag += 1
        } else {
          $('#keyvalue_error').html('')
        }
        if (this.settingInfor.sectorNumber === null || this.settingInfor.sectorNumber === '') {
          $('#sectornumber_error').html('セクタNoは必須項目です。')
          this.flag += 1
        } else if (this.settingInfor.sectorNumber > 255) {
          $('#sectornumber_error').html('セクタNoは0〜255の半角数字で入力してください。')
          this.flag += 1
        } else {
          $('#sectornumber_error').html('')
        }
      } else {
        $('#keyvalue_error').html('')
        $('#sectornumber_error').html('')
      }
      if (this.flag === 0) {
        this.saveNfcSetting()
      }
    },
    saveNfcSetting () {
      var vm = this
      vm.loading = true
      var Infor = {
        pCodeConfigType: vm.settingInfor.pCodeConfigType
      }
      switch (vm.settingInfor.pCodeConfigType) {
        case 0:
          break
        case 1:
          if (vm.settingInfor.isOwnerCodeValid) {
            Infor.pCodeConfig = {
              ownerCode: vm.settingInfor.ownerCode,
              isOwnerCodeValid: vm.settingInfor.isOwnerCodeValid,
              ownerCodePosition: [
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition1),
                  length: parseInt(vm.settingInfor.ownerCodeLength1)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition2),
                  length: parseInt(vm.settingInfor.ownerCodeLength2)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition3),
                  length: parseInt(vm.settingInfor.ownerCodeLength3)
                }
              ]
            }
          } else {
            Infor.pCodeConfig = {
              isOwnerCodeValid: vm.settingInfor.isOwnerCodeValid,
              ownerCodePosition: [
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition1),
                  length: parseInt(vm.settingInfor.ownerCodeLength1)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition2),
                  length: parseInt(vm.settingInfor.ownerCodeLength2)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition3),
                  length: parseInt(vm.settingInfor.ownerCodeLength3)
                }
              ]
            }
          }
          break
        case 2:
          if (vm.settingInfor.isOwnerCodeValid) {
            Infor.pCodeConfig = {
              ownerCode: vm.settingInfor.ownerCode,
              isOwnerCodeValid: vm.settingInfor.isOwnerCodeValid,
              ownerCodePosition: [
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition1),
                  length: parseInt(vm.settingInfor.ownerCodeLength1)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition2),
                  length: parseInt(vm.settingInfor.ownerCodeLength2)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition3),
                  length: parseInt(vm.settingInfor.ownerCodeLength3)
                }
              ]
            }
          } else {
            Infor.pCodeConfig = {
              isOwnerCodeValid: vm.settingInfor.isOwnerCodeValid,
              ownerCodePosition: [
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition1),
                  length: parseInt(vm.settingInfor.ownerCodeLength1)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition2),
                  length: parseInt(vm.settingInfor.ownerCodeLength2)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition3),
                  length: parseInt(vm.settingInfor.ownerCodeLength3)
                }
              ]
            }
          }
          break
        case 3:
          break
        case 4:
          if (vm.settingInfor.isOwnerCodeValid) {
            Infor.pCodeConfig = {
              ownerCode: vm.settingInfor.ownerCode,
              blockCount: parseInt(vm.settingInfor.blockCount),
              isOwnerCodeValid: vm.settingInfor.isOwnerCodeValid,
              type: 0,
              credential: {
                felica: {
                  systemCode: vm.settingInfor.systemCode,
                  serviceCode: vm.settingInfor.serviceCode
                }
              },
              ownerCodePosition: [
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition1),
                  length: parseInt(vm.settingInfor.ownerCodeLength1)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition2),
                  length: parseInt(vm.settingInfor.ownerCodeLength2)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition3),
                  length: parseInt(vm.settingInfor.ownerCodeLength3)
                }
              ],
              readPosition: [
                {
                  position: parseInt(vm.settingInfor.readPosition1),
                  length: parseInt(vm.settingInfor.readLength1)
                },
                {
                  position: parseInt(vm.settingInfor.readPosition2),
                  length: parseInt(vm.settingInfor.readLength2)
                },
                {
                  position: parseInt(vm.settingInfor.readPosition3),
                  length: parseInt(vm.settingInfor.readLength3)
                }
              ]
            }
          } else {
            Infor.pCodeConfig = {
              blockCount: parseInt(vm.settingInfor.blockCount),
              isOwnerCodeValid: vm.settingInfor.isOwnerCodeValid,
              type: 0,
              credential: {
                felica: {
                  systemCode: vm.settingInfor.systemCode,
                  serviceCode: vm.settingInfor.serviceCode
                }
              },
              ownerCodePosition: [
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition1),
                  length: parseInt(vm.settingInfor.ownerCodeLength1)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition2),
                  length: parseInt(vm.settingInfor.ownerCodeLength2)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition3),
                  length: parseInt(vm.settingInfor.ownerCodeLength3)
                }
              ],
              readPosition: [
                {
                  position: parseInt(vm.settingInfor.readPosition1),
                  length: parseInt(vm.settingInfor.readLength1)
                },
                {
                  position: parseInt(vm.settingInfor.readPosition2),
                  length: parseInt(vm.settingInfor.readLength2)
                },
                {
                  position: parseInt(vm.settingInfor.readPosition3),
                  length: parseInt(vm.settingInfor.readLength3)
                }
              ]
            }
          }
          break
        case 5:
          if (vm.settingInfor.isOwnerCodeValid) {
            Infor.pCodeConfig = {
              ownerCode: vm.settingInfor.ownerCode,
              isOwnerCodeValid: vm.settingInfor.isOwnerCodeValid,
              sectorNumber: parseInt(vm.settingInfor.sectorNumber),
              type: 1,
              credential: {
                mifare: {
                  keyType: parseInt(vm.settingInfor.keyType),
                  keyValue: vm.settingInfor.keyValue
                }
              },
              ownerCodePosition: [
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition1),
                  length: parseInt(vm.settingInfor.ownerCodeLength1)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition2),
                  length: parseInt(vm.settingInfor.ownerCodeLength2)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition3),
                  length: parseInt(vm.settingInfor.ownerCodeLength3)
                }
              ],
              readPosition: [
                {
                  position: parseInt(vm.settingInfor.readPosition1),
                  length: parseInt(vm.settingInfor.readLength1)
                },
                {
                  position: parseInt(vm.settingInfor.readPosition2),
                  length: parseInt(vm.settingInfor.readLength2)
                },
                {
                  position: parseInt(vm.settingInfor.readPosition3),
                  length: parseInt(vm.settingInfor.readLength3)
                }
              ]
            }
          } else {
            Infor.pCodeConfig = {
              isOwnerCodeValid: vm.settingInfor.isOwnerCodeValid,
              sectorNumber: parseInt(vm.settingInfor.sectorNumber),
              type: 1,
              credential: {
                mifare: {
                  keyType: parseInt(vm.settingInfor.keyType),
                  keyValue: vm.settingInfor.keyValue
                }
              },
              ownerCodePosition: [
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition1),
                  length: parseInt(vm.settingInfor.ownerCodeLength1)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition2),
                  length: parseInt(vm.settingInfor.ownerCodeLength2)
                },
                {
                  position: parseInt(vm.settingInfor.ownerCodePosition3),
                  length: parseInt(vm.settingInfor.ownerCodeLength3)
                }
              ],
              readPosition: [
                {
                  position: parseInt(vm.settingInfor.readPosition1),
                  length: parseInt(vm.settingInfor.readLength1)
                },
                {
                  position: parseInt(vm.settingInfor.readPosition2),
                  length: parseInt(vm.settingInfor.readLength2)
                },
                {
                  position: parseInt(vm.settingInfor.readPosition3),
                  length: parseInt(vm.settingInfor.readLength3)
                }
              ]
            }
          }
          break
      }
      console.log(Infor)
      this.$http.put(Config.OWNER_API + '/' + encodeURIComponent(localStorage.ownerId), Infor)
        .then(response => {
          this.loading = false
          this.message_success = Config.EDIT_SETTING_API_SUCCESS
          this.message_error = ''
        })
        .catch((error) => {
          this.message_success = ''
          if (error.body) {
            this.loading = false
            this.message_error = Config.ADD_API_ERROR
          } else {
            this.loading = false
            this.message_error = Config.SERVER_CONNECT_ERROR
          }
        })
    },
    checkEditStatus () {
      var vm = this
      if (!vm.fistTime) {
        vm.settingInfor.ownerCodePosition1 = 0
        vm.settingInfor.ownerCodePosition2 = 0
        vm.settingInfor.ownerCodePosition3 = 0
        vm.settingInfor.ownerCodeLength1 = 0
        vm.settingInfor.ownerCodeLength2 = 0
        vm.settingInfor.ownerCodeLength3 = 0
        vm.settingInfor.readPosition1 = 0
        vm.settingInfor.readPosition2 = 0
        vm.settingInfor.readPosition3 = 0
        vm.settingInfor.readLength1 = 0
        vm.settingInfor.readLength2 = 0
        vm.settingInfor.readLength3 = 0
        vm.settingInfor.ownerCode = ''
        vm.settingInfor.systemCode = ''
        vm.settingInfor.serviceCode = ''
        vm.settingInfor.blockCount = 0
        vm.settingInfor.keyType = 1
        vm.settingInfor.keyValue = ''
        vm.settingInfor.sectorNumber = ''
        vm.settingInfor.isOwnerCodeValid = false
      }
      switch (vm.settingInfor.pCodeConfigType) {
        case 0:
          vm.fistTime = false
          vm.editStatus = true
          vm.isFelica = true
          vm.isMifare = true
          vm.editStatusException = true
          break
        case 1:
          vm.fistTime = false
          vm.editStatus = true
          vm.isFelica = true
          vm.isMifare = true
          vm.editStatusException = false
          break
        case 2:
          vm.fistTime = false
          vm.editStatus = true
          vm.isFelica = true
          vm.isMifare = true
          vm.editStatusException = false
          break
        case 3:
          vm.fistTime = false
          vm.editStatus = true
          vm.isFelica = true
          vm.isMifare = true
          vm.editStatusException = true
          break
        case 4:
          vm.fistTime = false
          vm.editStatus = false
          vm.isFelica = true
          vm.isMifare = false
          vm.editStatusException = false
          break
        case 5:
          vm.fistTime = false
          vm.editStatus = false
          vm.isFelica = false
          vm.isMifare = true
          vm.editStatusException = false
          break
      }
    },
    // NFC読み取り設定種別取得
    getTypeInfo () {
      var vm = this
      this.$http.get(Config.CONFIG_PCODE_TYPE_API)
        .then(response => {
          vm.listNfcSetting = response.body.pCodeConfigTypes
        })
        .catch((error) => {
          console.log(error)
        })
    },
    isEmpty (obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          return false
        }
      }
      return true
    },
    getOwnerInfor () {
      var vm = this
      this.$http.get(Config.OWNER_API + '?ownerId=' + encodeURIComponent(localStorage.ownerId))
        .then(response => {
          console.log(response)
          vm.fistTime = true
          vm.settingInfor.pCodeConfigType = response.body.owners[0].pCodeConfigType
          vm.settingInfor.phonesBeValid = response.body.owners[0].phonesBeValid
          vm.settingInfor.keyTokenRefreshable = response.body.owners[0].keyTokenRefreshable
          vm.settingInfor.keyTokenLifetime = response.body.owners[0].keyTokenLifetime
          vm.settingInfor.keyTokenRefreshRate = response.body.owners[0].keyTokenRefreshRate
          vm.settingInfor.type = response.body.owners[0].pCodeConfig.type
          vm.settingInfor.isOwnerCodeValid = response.body.owners[0].pCodeConfig.isOwnerCodeValid
          vm.settingInfor.ownerCode = response.body.owners[0].pCodeConfig.ownerCode
          if (!vm.isEmpty(response.body.owners[0].pCodeConfig)) {
            var ownerCodePosition = response.body.owners[0].pCodeConfig.ownerCodePosition
            for (var i = 0; i < ownerCodePosition.length; i++) {
              switch (i) {
                case 0:
                  vm.settingInfor.ownerCodePosition1 = response.body.owners[0].pCodeConfig.ownerCodePosition[i].position
                  vm.settingInfor.ownerCodeLength1 = response.body.owners[0].pCodeConfig.ownerCodePosition[i].length
                  break
                case 1:
                  vm.settingInfor.ownerCodePosition2 = response.body.owners[0].pCodeConfig.ownerCodePosition[i].position
                  vm.settingInfor.ownerCodeLength2 = response.body.owners[0].pCodeConfig.ownerCodePosition[i].length
                  break
                case 2:
                  vm.settingInfor.ownerCodePosition3 = response.body.owners[0].pCodeConfig.ownerCodePosition[i].position
                  vm.settingInfor.ownerCodeLength3 = response.body.owners[0].pCodeConfig.ownerCodePosition[i].length
                  break
              }
            }
            var readPosition = response.body.owners[0].pCodeConfig.readPosition
            for (var j = 0; j < readPosition.length; j++) {
              switch (j) {
                case 0:
                  vm.settingInfor.readPosition1 = response.body.owners[0].pCodeConfig.readPosition[j].position
                  vm.settingInfor.readLength1 = response.body.owners[0].pCodeConfig.readPosition[j].length
                  break
                case 1:
                  vm.settingInfor.readPosition2 = response.body.owners[0].pCodeConfig.readPosition[j].position
                  vm.settingInfor.readLength2 = response.body.owners[0].pCodeConfig.readPosition[j].length
                  break
                case 2:
                  vm.settingInfor.readPosition3 = response.body.owners[0].pCodeConfig.readPosition[j].position
                  vm.settingInfor.readLength3 = response.body.owners[0].pCodeConfig.readPosition[j].length
                  break
              }
            }
            if (vm.settingInfor.type === 0) {
              console.log(response.body.owners[0].pCodeConfig)
              if (!vm.isEmpty(response.body.owners[0].pCodeConfig.credential)) {
                vm.settingInfor.systemCode = response.body.owners[0].pCodeConfig.credential.felica.systemCode
                vm.settingInfor.serviceCode = response.body.owners[0].pCodeConfig.credential.felica.serviceCode
              }
              vm.settingInfor.blockCount = response.body.owners[0].pCodeConfig.blockCount
            } else {
              vm.settingInfor.keyType = response.body.owners[0].pCodeConfig.credential.mifare.keyType
              vm.settingInfor.keyValue = response.body.owners[0].pCodeConfig.credential.mifare.keyValue
              vm.settingInfor.sectorNumber = response.body.owners[0].pCodeConfig.sectorNumber
            }
          }
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>

<style>
input[type=checkbox].ace.ace-switch+.lbl::before{
  text-indent: 25px!important;
  content: "無効"!important;
}
input[type=checkbox].ace.ace-switch:checked+.lbl::before{
  text-indent: 5px!important;
  content: "有効"!important;
}
input[type=number]{
  width: 160px
}
.table>tbody>tr>td, .table>tbody>tr>th, .table>tfoot>tr>td, .table>tfoot>tr>th, .table>thead>tr>td, .table>thead>tr>th {
  vertical-align: text-top;
}
.mifare, .possition, .felica, .code, .nfc{
  margin-bottom: 10px
}
.main-title {
  width: 150px;
  vertical-align: middle;
  display: table-cell;
}
.possition .sub-title {
  width: 50px;
  vertical-align: middle;
  display: table-cell;
  text-align: center;
}
.felica .sub-title,.mifare .sub-title{
  width: 115px;
  vertical-align: middle;
  display: table-cell;
  text-align: center;
}
.bootstrap-timepicker-widget table td input {
  width: 35px;
}
.checkbox label, .radio label {
  padding-left: 10px!important
}
.checkbox-box{
  margin-right: 15px
}
.edit-bottom,.delete-bottom{
  width: 100%;
  margin-bottom: 15px
}
</style>



// WEBPACK FOOTER //
// src/views/setting/SettingList.vue